"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const constants_1 = __importStar(require("../utils/constants"));
const _base_1 = require("./_base");
/**
 * ![CanceledIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiIgaGVpZ2h0PSIzMCIgd2lkdGg9IjMwIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjZmZmOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8dGl0bGU+Q2FuY2VsZWQ8L3RpdGxlPgogIDxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPgogICAgPGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj4KICAgICAgPHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTAuMTIsNS4xNyw4LDcuMjksNS44OCw1LjE3YS41LjUsMCwwLDAtLjcxLjcxTDcuMjksOCw1LjE3LDEwLjEyYS41LjUsMCwwLDAsLjcxLjcxTDgsOC43MWwyLjEyLDIuMTJhLjUuNSwwLDAsMCwuNzEtLjcxTDguNzEsOGwyLjEyLTIuMTJhLjUuNSwwLDAsMC0uNzEtLjcxWiIvPgogICAgICA8cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik04LDE2YTgsOCwwLDEsMSw4LThBOCw4LDAsMCwxLDgsMTZaTTgsMWE3LDcsMCwxLDAsNyw3QTcsNywwLDAsMCw4LDFaIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K)
 */
exports.CanceledIcon = (_a) => {
    var { size = 18, color } = _a, props = __rest(_a, ["size", "color"]);
    const iconColor = constants_1.expandColor(constants_1.default, color) || "currentColor";
    return (React.createElement(_base_1.Svg, Object.assign({ viewBox: "0 0 16 16", fill: iconColor, width: size, height: size, size: size, role: props.onClick ? "button" : undefined, tabIndex: props.onClick ? 0 : undefined }, props),
        React.createElement("path", { d: "M10.12 5.17L8 7.29 5.88 5.17a.5.5 0 0 0-.71.71L7.29 8l-2.12 2.12a.5.5 0 0 0 .71.71L8 8.71l2.12 2.12a.5.5 0 0 0 .71-.71L8.71 8l2.12-2.12a.5.5 0 0 0-.71-.71z" }),
        React.createElement("path", { d: "M8 16a8 8 0 1 1 8-8 8 8 0 0 1-8 8zM8 1a7 7 0 1 0 7 7 7 7 0 0 0-7-7z" })));
};
//# sourceMappingURL=Icon.Canceled.js.map